module.exports = __webpack_public_path__ + "static/img/Busqueda (azul).5058baff.png";